import React from "react";
import { TouchableOpacity, Text } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import GlobalStyles from "../../Resources/Styles";
import Colors from "../../Resources/Color";
import Fonts from "../../Resources/Fonts";
import { useTranslation } from "react-i18next";

const BackButton = ({ action, backString = "back-string" }) => {
  const { t } = useTranslation();
  return (
    <TouchableOpacity
      onPress={action}
      style={{
        flexDirection: "row",
        alignItems: "center",
        alignSelf: "flex-start",
        paddingRight: 4,
      }}
    >
      <Ionicons name="chevron-back" size={20} color={Colors.bubbleColor} />
      <Text style={[Fonts.medium14, { color: Colors.bubbleColor }]}>
        {t(backString)}
      </Text>
    </TouchableOpacity>
  );
};

export default BackButton;
